import React, {useCallback, useState} from 'react';
import ButtonContainer from '../../../../components/Simple/ButtonContainer';
import SMCButton from '../../../../components/Simple/SMCButton';
import {useTranslation} from 'react-i18next';
import LabelContainer from '../../../../components/Page/LabelContainer';
import SMCTable from '../../../../components/core/SMCTable/SMCTable';
import {dateToString} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {PortalSettingsGetSchema} from '../../../../api/DBSchema/PortalSettings';
import ExternalCaEditorModal from '../../../PopupPages/ExternalCaEditorModal';
import {useBoolean} from '../../../../utils/hooks';
import SMCLink from '../../../../components/Simple/SMCLink';
import editLogo from '../../../../assets/images/edit.png';
import Api from '../../../../api/SMPFetchHelper';
import {useSMCErrorHandler} from '../../../../utils/errorUtils';

const pageSchema = PortalSettingsGetSchema.pages.certificates;
const pageId = pageSchema.pageId;

function PortalCertificates({
    portalSettingsObject,
    setPortalSettingsData,
    serviceDomainName,
    width,
    height
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();

    const pageData = portalSettingsObject[pageId];
    const certificates = pageData[pageSchema.dataList];
    const certificatesSchema = pageSchema.dataListSchema;

    const [isExternalCaEditorOpen, openExternalCaEditor, closeExternalCaEditor] = useBoolean(false);
    const [editObject, setEditObject] = useState(null);

    const deleteCertificate = useCallback((certificate) => {
        const certificateName = certificate[certificatesSchema.name];
        const certificateDn   = certificate[certificatesSchema.dn];

        if (window.confirm(t('SMC_SETTINGS_CERT_DELETE_QUES', [certificateName]))) {
            const certificatesWithoutDeleted = certificates.filter(cert => cert[certificatesSchema.dn] !== certificateDn);
            setPortalSettingsData([pageId, pageSchema.dataList], certificatesWithoutDeleted);
            Api.deleteCaCertificate(certificateDn)
            .catch(e => {
                const errorMessage = getErrorMessage(e);
                alert(errorMessage);
            });
        }
    }, [certificates, certificatesSchema, setPortalSettingsData, getErrorMessage, t]);

    const addCertificate = useCallback((certificateData) => {
        const certificatesWithAdded = [...certificates, certificateData];
        setPortalSettingsData([pageId, pageSchema.dataList], certificatesWithAdded);
    }, [certificates, setPortalSettingsData]);

    const NameCell = React.memo(({value, object}) => {
        return <span><img align="absmiddle" alt="" src={editLogo} /><SMCLink inline onClick={() => { setEditObject(object); openExternalCaEditor(); }}>{value}</SMCLink></span>;
    });

    const ExpirationCell = React.memo(({value}) => {
        return value ? <span>{dateToString(value)}</span> : null;
    });    
        
    const DeleteCell = React.memo(({object}) => {
        return <SMCLink onClick={() => deleteCertificate(object)}><SMCIcon icon="delete" /></SMCLink>;
    });    

    const columns = [
        { id: 'name',       header: t('SMC_SETTINGS_CERT_TAB_NAME'), accessor: certificatesSchema.name,           width: 150,                  Cell: NameCell       },
        { id: 'dn',         header: t('SMC_SETTINGS_CERT_TAB_DN'),   accessor: certificatesSchema.dn,             width: 150,                                       },
        { id: 'expiration', header: t('SMC_SETTINGS_CERT_TAB_EXP'),  accessor: certificatesSchema.expirationDate, width: 150,                  Cell: ExpirationCell },
        { id: 'delete',     header: '',                                                                           width: 32,  align: 'center', Cell: DeleteCell     }
    ];

    return (
        <div style={{ width, height, padding: '0px 60px 20px 20px'}}>
                {/* Header */}
                <div className="ObjectEditorHeader Tabs">
                    <LabelContainer label="Name:" value={serviceDomainName} />
                </div>
                <div>
                    <ButtonContainer>
                        <SMCButton variant="ghost" icon="plus" onClick={() => { setEditObject(null); openExternalCaEditor(); }}>{t('SMC_GEN_ADD')}</SMCButton>
                    </ButtonContainer>
                    <SMCTable
                        columns={columns}
                        content={certificates}
                        width={width-80}
                        height={height-120}
                        hasCheckboxColumn={false}
                    />
                </div>
                {/* Popup windows */}
                <ExternalCaEditorModal
                    isOpen={isExternalCaEditorOpen}
                    onRequestClose={closeExternalCaEditor}
                    defaultObject={editObject}
                    onSuccess={certData => {
                        addCertificate(certData);
                        closeExternalCaEditor();
                    }}
                />
        </div>
    );
}

export default React.memo(PortalCertificates);